'use client';

import { c as _c } from "react/compiler-runtime";
import type { DocumentoPadraoProduto, DocumentoPadraoTipo, DocumentosPadraoFiltroValidade, DocumentosPadraoFiltros as Filtros, DocumentosPadraoSetor } from '@/features/documentosPadrao/types/documentosPadraoTypes';
import { DOCUMENTO_PADRAO_PRODUTO_LABEL, DOCUMENTO_PADRAO_PRODUTOS, DOCUMENTO_PADRAO_TIPO_LABEL, DOCUMENTO_PADRAO_TIPOS } from '@/features/documentosPadrao/utils/documentosPadraoRegras';
import { FilterChip } from '@/shared/components/ui/common/FilterChip';
import { Select } from '@/shared/components/ui/common/Select';
import { TextField } from '@/shared/components/ui/common/TextField';
import { FeatherSearch, FeatherX } from '@subframe/core';
const VALIDADE_OPCOES: {
  value: DocumentosPadraoFiltroValidade;
  label: string;
}[] = [{
  value: 'todas',
  label: 'Todas as validades'
}, {
  value: 'vigentes',
  label: 'Vigentes'
}, {
  value: 'vencendo',
  label: 'Vencendo em 30 dias'
}, {
  value: 'vencidas',
  label: 'Vencidas'
}, {
  value: 'criticas',
  label: 'Vencidas ou vencendo'
}, {
  value: 'sem-validade',
  label: 'Não expira'
}];
interface DocumentosPadraoFiltrosProps {
  filtros: Filtros;
  setores: DocumentosPadraoSetor[];
  temFiltrosAtivos: boolean;
  onAtualizarFiltros: (parcial: Partial<Filtros>) => void;
  onLimparFiltros: () => void;
}
export function DocumentosPadraoFiltros(t0) {
  const $ = _c(72);
  const {
    filtros,
    setores,
    temFiltrosAtivos,
    onAtualizarFiltros,
    onLimparFiltros
  } = t0;
  let t1;
  if ($[0] !== filtros.setorId || $[1] !== setores) {
    let t2;
    if ($[3] !== filtros.setorId) {
      t2 = setor => setor.id === filtros.setorId;
      $[3] = filtros.setorId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = setores.find(t2);
    $[0] = filtros.setorId;
    $[1] = setores;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const setorSelecionado = t1;
  let t2;
  if ($[5] !== filtros.tipo || $[6] !== onAtualizarFiltros) {
    t2 = filtros.tipo !== "todos" ? {
      id: "tipo",
      rotulo: `Tipo: ${DOCUMENTO_PADRAO_TIPO_LABEL[filtros.tipo]}`,
      limpar: () => onAtualizarFiltros({
        tipo: "todos"
      })
    } : null;
    $[5] = filtros.tipo;
    $[6] = onAtualizarFiltros;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== onAtualizarFiltros || $[9] !== setorSelecionado) {
    t3 = setorSelecionado ? {
      id: "setor",
      rotulo: `Setor: ${setorSelecionado.nome}`,
      limpar: () => onAtualizarFiltros({
        setorId: "todos"
      })
    } : null;
    $[8] = onAtualizarFiltros;
    $[9] = setorSelecionado;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== filtros.produto || $[12] !== onAtualizarFiltros) {
    t4 = filtros.produto !== "todos" ? {
      id: "produto",
      rotulo: `Produto: ${DOCUMENTO_PADRAO_PRODUTO_LABEL[filtros.produto]}`,
      limpar: () => onAtualizarFiltros({
        produto: "todos"
      })
    } : null;
    $[11] = filtros.produto;
    $[12] = onAtualizarFiltros;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== filtros.validade || $[15] !== onAtualizarFiltros) {
    t5 = filtros.validade !== "todas" ? {
      id: "validade",
      rotulo: `Validade: ${VALIDADE_OPCOES.find(opcao => opcao.value === filtros.validade)?.label}`,
      limpar: () => onAtualizarFiltros({
        validade: "todas"
      })
    } : null;
    $[14] = filtros.validade;
    $[15] = onAtualizarFiltros;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = [t2, t3, t4, t5].filter(_temp);
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const chips = t6;
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherSearch />;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== onAtualizarFiltros) {
    t8 = evento => onAtualizarFiltros({
      busca: evento.target.value
    });
    $[23] = onAtualizarFiltros;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== filtros.busca || $[26] !== t8) {
    t9 = <TextField className="mobile:w-full w-[340px]" label="" helpText="" icon={t7}><TextField.Input placeholder="Buscar por nome, tipo ou parte vinculada" value={filtros.busca} onChange={t8} /></TextField>;
    $[25] = filtros.busca;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const t10 = filtros.tipo;
  let t11;
  if ($[28] !== onAtualizarFiltros) {
    t11 = valor => onAtualizarFiltros({
      tipo: valor as DocumentoPadraoTipo | 'todos'
    });
    $[28] = onAtualizarFiltros;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Select.Item value="todos">Todos os tipos</Select.Item>;
    t13 = DOCUMENTO_PADRAO_TIPOS.map(_temp2);
    $[30] = t12;
    $[31] = t13;
  } else {
    t12 = $[30];
    t13 = $[31];
  }
  let t14;
  if ($[32] !== filtros.tipo || $[33] !== t11) {
    t14 = <Select className="w-[178px]" value={t10} onValueChange={t11}>{t12}{t13}</Select>;
    $[32] = filtros.tipo;
    $[33] = t11;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = filtros.setorId;
  let t16;
  if ($[35] !== onAtualizarFiltros) {
    t16 = valor_0 => onAtualizarFiltros({
      setorId: valor_0
    });
    $[35] = onAtualizarFiltros;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Select.Item value="todos">Todos os setores</Select.Item>;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== setores) {
    t18 = setores.map(_temp3);
    $[38] = setores;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== filtros.setorId || $[41] !== t16 || $[42] !== t18) {
    t19 = <Select className="w-[178px]" value={t15} onValueChange={t16}>{t17}{t18}</Select>;
    $[40] = filtros.setorId;
    $[41] = t16;
    $[42] = t18;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const t20 = filtros.produto;
  let t21;
  if ($[44] !== onAtualizarFiltros) {
    t21 = valor_1 => onAtualizarFiltros({
      produto: valor_1 as DocumentoPadraoProduto | 'todos'
    });
    $[44] = onAtualizarFiltros;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  let t23;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Select.Item value="todos">Todos os produtos</Select.Item>;
    t23 = DOCUMENTO_PADRAO_PRODUTOS.map(_temp4);
    $[46] = t22;
    $[47] = t23;
  } else {
    t22 = $[46];
    t23 = $[47];
  }
  let t24;
  if ($[48] !== filtros.produto || $[49] !== t21) {
    t24 = <Select className="w-[178px]" value={t20} onValueChange={t21}>{t22}{t23}</Select>;
    $[48] = filtros.produto;
    $[49] = t21;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  const t25 = filtros.validade;
  let t26;
  if ($[51] !== onAtualizarFiltros) {
    t26 = valor_2 => onAtualizarFiltros({
      validade: valor_2 as DocumentosPadraoFiltroValidade
    });
    $[51] = onAtualizarFiltros;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = VALIDADE_OPCOES.map(_temp5);
    $[53] = t27;
  } else {
    t27 = $[53];
  }
  let t28;
  if ($[54] !== filtros.validade || $[55] !== t26) {
    t28 = <Select className="w-[196px]" value={t25} onValueChange={t26}>{t27}</Select>;
    $[54] = filtros.validade;
    $[55] = t26;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t14 || $[58] !== t19 || $[59] !== t24 || $[60] !== t28) {
    t29 = <div className="mobile:flex-col mobile:items-stretch flex flex-wrap items-center gap-2">{t14}{t19}{t24}{t28}</div>;
    $[57] = t14;
    $[58] = t19;
    $[59] = t24;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t29 || $[63] !== t9) {
    t30 = <div className="mobile:flex-col mobile:items-stretch flex w-full flex-wrap items-center justify-between gap-4">{t9}{t29}</div>;
    $[62] = t29;
    $[63] = t9;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== chips || $[66] !== onLimparFiltros || $[67] !== temFiltrosAtivos) {
    t31 = temFiltrosAtivos && <div className="flex w-full flex-wrap items-center gap-2"><span className="text-caption font-caption text-subtext-color">Filtros ativos:</span>{chips.map(_temp6)}<FilterChip onClick={onLimparFiltros}>Limpar filtros</FilterChip></div>;
    $[65] = chips;
    $[66] = onLimparFiltros;
    $[67] = temFiltrosAtivos;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] !== t30 || $[70] !== t31) {
    t32 = <div className="flex w-full flex-col gap-3 border-b border-solid border-neutral-100 px-6 py-5">{t30}{t31}</div>;
    $[69] = t30;
    $[70] = t31;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  return t32;
}
function _temp6(chip_0) {
  return <FilterChip key={chip_0.id} active={true} onClick={chip_0.limpar}>{chip_0.rotulo}<FeatherX className="h-3 w-3" /></FilterChip>;
}
function _temp5(opcao_0) {
  return <Select.Item key={opcao_0.value} value={opcao_0.value}>{opcao_0.label}</Select.Item>;
}
function _temp4(produto) {
  return <Select.Item key={produto} value={produto}>{DOCUMENTO_PADRAO_PRODUTO_LABEL[produto]}</Select.Item>;
}
function _temp3(setor_0) {
  return <Select.Item key={setor_0.id} value={setor_0.id}>{setor_0.nome}</Select.Item>;
}
function _temp2(tipo) {
  return <Select.Item key={tipo} value={tipo}>{DOCUMENTO_PADRAO_TIPO_LABEL[tipo]}</Select.Item>;
}
function _temp(chip) {
  return chip !== null;
}